import { create } from "zustand";

const useInterviewerDashboard = create((set) => ({
  activeTab: 'slots',

  setActiveTab: (tab) => {
    set({ activeTab: tab });
  },

  resetTab: () => {
    set({ activeTab: 'slots' });
  },
}));

export default useInterviewerDashboard; 